import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Glyphicon } from 'react-bootstrap';
import { logout } from 'actions/user';
import { isCTIAUser } from 'helpers/Users';

class UserinfoSticky extends Component {
  onLogoutClick = () => {
    const { user, logout, history } = this.props;
    const redirectUrl = isCTIAUser(user) ? '/login' : '/home';

    logout(() => {
      history.push(redirectUrl);
    });
  };

  render() {
    const { user, isAuth } = this.props;
    if (isAuth) {
      return (
        <div id="xs-userinfo">
          <Glyphicon glyph="user" className="green" style={{ paddingRight: 10 }} />
          <span className="green bold" style={{ paddingRight: 10 }}>
            {user.name}
          </span>{' '}
          <a onClick={this.onLogoutClick} className="nav-logout-link">
            logout
          </a>
        </div>
      );
    }

    return null;
  }
}

UserinfoSticky.propTypes = {
  isAuth: PropTypes.bool
};

function mapStateToProps({ user }) {
  return { user };
}

export default connect(
  mapStateToProps,
  { logout }
)(UserinfoSticky);



// WEBPACK FOOTER //
// ./src/components/MainMenu/UserinfoSticky.js